package com.appsyde.shared.modules.ticket.domain

class NotAssigneeException(
    message: String? = "Only assignee can acquire lock",
    cause: Throwable? = null
) : Exception(message, cause)
